<template>
  <div class="amapDemoBox">
    <v-title title="更换地址" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack()"></v-title>
    <div class="amap-page-container">
      <el-amap vid="amapDemo" :center="[Number(detailData.longitude),Number(detailData.latitude)]" :zoom="zoom" :events="events" class="amap-demo">
      </el-amap>

    </div>
    <div class="addressDetailBox">
      <p class="addressDetailBox-p">地址纬度 ：{{ detailData.latitude }}</p>
      <p class="addressDetailBox-p"> 地址精度 ：{{ detailData.longitude }}</p>
      <p class="addressDetailBox-p">详细地址 ：{{ detailData.clientAddress }}</p>
      <p class="submit-btn" @click="goback(true)">确定</p>
    </div>
  </div>
</template>

<script>
// let amapManager = new VueAMap.AMapManager();
let preData = ''// 更改
export default {
  name: 'AddressMap',
  data () {
    const self = this
    return {
      saveRoute: true,
      zoom: 16,
      center: [121.59996, 31.197646],
      amapManager: '',
      detailData: {},
      events: {

        init (map) {
          console.log('/////////////////////')
          console.log(self)
          const makers = []
          // var marker = new AMap.Marker({
          //         position: map.getCenter()   ,
          //         offset: new AMap.Pixel(-13, -30)
          // });
          // map.add(marker);
          //  makers.push(marker)
          // eslint-disable-next-line no-undef
          var text = new AMap.Text({
            text: self.detailData.clientName,
            anchor: 'center', // 设置文本标记锚点
            draggable: false,
            cursor: 'pointer',
            style: {

            },
            position: [Number(self.detailData.longitude), Number(self.detailData.latitude)]
          })
          makers.push(text)
          text.setMap(map)
          // eslint-disable-next-line no-undef
          AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker) {
            var positionPicker = new PositionPicker({
              mode: 'dragMap',
              map: map
            })

            // 创建纯文本标记

            positionPicker.on('success', function (positionResult) {
              // map.remove(makers)
              map.remove(makers)
              // var marker = new AMap.Marker({
              //     position: map.getCenter()   ,
              //     offset: new AMap.Pixel(-13, -30)
              // });
              // marker.setLabel({
              //     offset: new AMap.Pixel(20, 20),  //设置文本标注偏移量
              //     content: self.detailData.clientName , //设置文本标注内容
              //     direction: 'right' //设置文本标注方位
              // });
              // map.add(marker);
              // makers.push(marker)
              // eslint-disable-next-line no-undef
              var text = new AMap.Text({
                text: self.detailData.clientName,
                anchor: 'center', // 设置文本标记锚点
                draggable: false,
                cursor: 'pointer',

                position: [Number(self.detailData.longitude), Number(self.detailData.latitude)]
              })
              text.setMap(map)
              makers.push(text)
              console.log('修改信息')
              console.log(positionResult.address)
              self.detailData.longitude = positionResult.position.lng
              self.detailData.latitude = positionResult.position.lat
              self.detailData.clientAddress = positionResult.address
              console.log(self.detailData, '更改之后的')

              // marker.setMap(map);
              // marker.setLabel({
              //     offset: new AMap.Pixel(20, 20),  //设置文本标注偏移量
              //     content: self.detailData.clientName , //设置文本标注内容
              //     direction: 'right' //设置文本标注方位
              // });

              //    ${self.detailData.clientName}
            })

            positionPicker.start()
            map.panBy(0, 1)
            // map.add(marker);

            // eslint-disable-next-line no-undef
            map.addControl(new AMap.ToolBar({
              liteStyle: true
            }))
          })
        }
      }
    }
  },
  created () {
    this.detailData = JSON.parse(this.$route.query.data)
    console.log('详细信息', this.detailData)
    preData = JSON.parse(this.$route.query.data)
  },
  mounted () {

  },
  methods: {
    goBack () {
      this.$router.replace({ name: 'addDetail', query: { frash: false, data: JSON.stringify(preData) } })
    },
    goback (bool) {
      this.$router.replace({ name: 'addDetail', query: { data: JSON.stringify(this.detailData), frash: bool } })
    }
  }

}

</script>

<style lang="stylus" scoped>
    .amapDemoBox{
        height 100%
        .amap-touch-toolbar .amap-zoomcontrol{
           bottom -100px
        }
    }
    .amap-page-container{
        height 100%
        position relative
        top 0px
        z-index 0
    }
    .amap-demo {
        height: 100%;
        .amap-overlay-text-container{
            color red
        }
     }
     .addressDetailBox{
         position fixed
         bottom 0
         width 600px
         left 0
         background #fff
         padding 10px 30px
         .addressDetailBox-p{
             border-botom 1px solid #eee
             line-height 50px
             font-size 26px
         }
        .submit-btn{
            width 300px
            line-height 50px
            background #8758e5
            border-radius 20px
            color #ffffff
            text-align center
            margin  30px auto

         }

     }

     .amap-labels{
         padding-bottom 100px
     }
</style>
